var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactiveServiceProviderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_53_49)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3 26.8875C6.52499 28.0125 -1.01251 20.5875 0.112494 11.7C0.899994 5.73751 5.73749 0.787515 11.7 0.112515C20.475 -1.01249 28.0125 6.41252 26.8875 15.3C26.1 21.2625 21.2625 26.1 15.3 26.8875ZM15.4125 2.36251C7.76249 1.12501 1.12499 7.76251 2.36249 15.4125C3.14999 20.025 6.86249 23.85 11.5875 24.6375C19.2375 25.875 25.875 19.2375 24.6375 11.5875C23.85 6.97502 20.025 3.15001 15.4125 2.36251Z",
    fill: "#E4993D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.29998 4.72504L22.275 20.5875L20.7 22.275L4.72498 6.30004",
    fill: "#E4993D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_53_49"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveServiceProviderIcon);
export default __webpack_public_path__ + "static/media/inactiveServiceProviderIcon.f805be20bd7038ef530de151b57ce58b.svg";
export { ForwardRef as ReactComponent };